import React from "react";
import PageHeaderWrapper from "../../components/PageHeaderWrapper";
import { connect } from "react-redux";
import { Card, Row, Col, DatePicker, Spin, Icon, Empty, Statistic, Alert, Select } from "antd";
import moment from "moment";
import Request from "../../request";

const { RangePicker } = DatePicker;
const { Option } = Select;

class VisaSubmissionApprovalReport extends React.Component {
    state = {
        time: { from: null, to: null },
        studentBranchId: undefined,
        branches: [],
        loading: false,
        report: null,
        error: null,
    };

    componentDidMount() {
        this.loadBranches();
    }

    loadBranches = async () => {
        const response = await Request.loadSimpleBranch({ results: 1000, sortField: "branchName" });
        const branches = response && response.data ? response.data : [];
        this.setState({ branches });
    };

    chooseRangerPicker = (date) => {
        if (!date || date.length < 2) {
            this.setState({ time: { from: null, to: null }, report: null, error: null });
            return;
        }

        const time = {
            from: moment(date[0]).startOf("day"),
            to: moment(date[1]).endOf("day"),
        };

        this.setState({ time }, () => this.loadData());
    };

    chooseBranch = (studentBranchId) => {
        this.setState({ studentBranchId }, () => this.loadData());
    };

    loadData = async () => {
        const { time, studentBranchId } = this.state;
        if (!time.from || !time.to) return;

        this.setState({ loading: true, error: null });
        const params = { time };
        if (studentBranchId) {
            params.studentBranchId = studentBranchId;
        }

        try {
            const response = await Request.getVisaSubmissionApprovalReport(params);

            if (response && response.success && response.data) {
                this.setState({ report: response.data, error: null, loading: false });
            } else {
                this.setState({
                    report: null,
                    error: (response && response.message) || "Failed to load report",
                    loading: false,
                });
            }
        } catch (error) {
            this.setState({ loading: false, report: null, error: "Something went wrong while loading the report" });
        }
    };

    render() {
        const { loading, report, error, branches, studentBranchId } = this.state;

        const submitted = report ? report.submitted || 0 : 0;
        const approved = report ? report.approved || 0 : 0;
        const refused = report ? report.refused || 0 : 0;
        const waiting = report ? report.waiting || 0 : 0;
        const resultReceived = report ? report.resultReceived || 0 : 0;

        return (
            <PageHeaderWrapper title="Visa Submission & Result Report">
                <Card
                    bordered={false}
                    style={{ marginBottom: 24, borderRadius: "8px", border: "1px solid #f0f0f0" }}
                    bodyStyle={{ padding: "16px 24px" }}
                >
                    <Row type="flex" align="middle" gutter={24}>
                        <Col>
                            <div style={{ marginBottom: 4, fontSize: "12px", color: "#8c8c8c", fontWeight: 600 }}>PERIOD</div>
                            <RangePicker
                                format="YYYY-MM-DD"
                                onChange={this.chooseRangerPicker}
                                style={{ width: 280 }}
                            />
                        </Col>

                        <Col>
                            <div style={{ marginBottom: 4, fontSize: "12px", color: "#8c8c8c", fontWeight: 600 }}>BRANCH</div>
                            <Select
                                showSearch
                                allowClear
                                optionFilterProp="children"
                                value={studentBranchId}
                                placeholder="All Branches"
                                style={{ width: 220 }}
                                onChange={this.chooseBranch}
                            >
                                {branches.map(branch => (
                                    <Option key={branch._id} value={branch._id}>{branch.branchName}</Option>
                                ))}
                            </Select>
                        </Col>

                        <Col style={{ marginLeft: "auto", paddingTop: "20px" }}>
                            {loading && <Spin indicator={<Icon type="loading" style={{ fontSize: 24 }} spin />} />}
                        </Col>
                    </Row>
                </Card>

                {error && !loading && (
                    <Alert
                        type="error"
                        message={error}
                        showIcon
                        style={{ marginBottom: 24, borderRadius: "8px" }}
                    />
                )}

                {!report && !error && !loading && (
                    <Card bordered={false} style={{ borderRadius: "8px", textAlign: "center", padding: "60px 0" }}>
                        <Empty description="Select a date range to view the report" />
                    </Card>
                )}

                {report && !loading && (
                    <React.Fragment>
                        <Row gutter={16} style={{ marginBottom: 16 }}>
                            <Col span={12}>
                                <Card bordered={false} style={{ borderRadius: "8px", borderLeft: "4px solid #1890ff", background: "linear-gradient(to right, #ffffff, #e6f7ff)", boxShadow: "0 2px 8px rgba(0,0,0,0.05)" }}>
                                    <Statistic title={<span style={{ textTransform: "uppercase", fontSize: "11px", letterSpacing: "0.5px" }}>Visas Submitted</span>} value={submitted} prefix={<Icon type="file-done" theme="filled" style={{ color: "#1890ff" }} />} />
                                </Card>
                            </Col>
                            <Col span={12}>
                                <Card bordered={false} style={{ borderRadius: "8px", borderLeft: "4px solid #722ed1", background: "linear-gradient(to right, #ffffff, #f9f0ff)", boxShadow: "0 2px 8px rgba(0,0,0,0.05)" }}>
                                    <Statistic title={<span style={{ textTransform: "uppercase", fontSize: "11px", letterSpacing: "0.5px" }}>Results Received (Approved + Refused)</span>} value={resultReceived} prefix={<Icon type="solution" theme="filled" style={{ color: "#722ed1" }} />} />
                                </Card>
                            </Col>
                        </Row>

                        <Row gutter={16}>
                            <Col span={8}>
                                <Card bordered={false} style={{ borderRadius: "8px", borderLeft: "4px solid #52c41a", background: "linear-gradient(to right, #ffffff, #f6ffed)", boxShadow: "0 2px 8px rgba(0,0,0,0.05)" }}>
                                    <Statistic title={<span style={{ textTransform: "uppercase", fontSize: "11px", letterSpacing: "0.5px" }}>Approved</span>} value={approved} prefix={<Icon type="check-circle" theme="filled" style={{ color: "#52c41a" }} />} />
                                </Card>
                            </Col>
                            <Col span={8}>
                                <Card bordered={false} style={{ borderRadius: "8px", borderLeft: "4px solid #f5222d", background: "linear-gradient(to right, #ffffff, #fff1f0)", boxShadow: "0 2px 8px rgba(0,0,0,0.05)" }}>
                                    <Statistic title={<span style={{ textTransform: "uppercase", fontSize: "11px", letterSpacing: "0.5px" }}>Refused</span>} value={refused} prefix={<Icon type="close-circle" theme="filled" style={{ color: "#f5222d" }} />} />
                                </Card>
                            </Col>
                            <Col span={8}>
                                <Card bordered={false} style={{ borderRadius: "8px", borderLeft: "4px solid #faad14", background: "linear-gradient(to right, #ffffff, #fffbe6)", boxShadow: "0 2px 8px rgba(0,0,0,0.05)" }}>
                                    <Statistic title={<span style={{ textTransform: "uppercase", fontSize: "11px", letterSpacing: "0.5px" }}>Waiting</span>} value={waiting} prefix={<Icon type="clock-circle" theme="filled" style={{ color: "#faad14" }} />} />
                                </Card>
                            </Col>
                        </Row>
                    </React.Fragment>
                )}
            </PageHeaderWrapper>
        );
    }
}

const mapStateToProps = ({ global }) => ({
    loading: global.buttonLoading,
});

export default connect(mapStateToProps)(VisaSubmissionApprovalReport);
